const contratoEstadoColors = {
  ACTIVO: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  VENCIDO: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
  RESCINDIDO: "bg-gray-200 text-gray-600 dark:bg-gray-700/30 dark:text-gray-400",
};

const vencimientoColors = {
  VENCIDO: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
  POR_VENCER: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  VIGENTE: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  SIN_FECHA: "bg-gray-100 text-gray-500 dark:bg-gray-700/30 dark:text-gray-400",
};

const aumentoColors = {
  PENDIENTE: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  PROXIMO: "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400",
};

export function getContratoEstadoClasses(estado) {
  return contratoEstadoColors[estado] || "bg-gray-100 text-gray-600 dark:bg-gray-700/30 dark:text-gray-400";
}

export function getVencimientoClasses(estado) {
  return vencimientoColors[estado] || vencimientoColors.SIN_FECHA;
}

export function getAumentoClasses(tipo) {
  return aumentoColors[tipo] || "bg-gray-100 text-gray-500 dark:bg-gray-700/30 dark:text-gray-400";
}
